import {
  createRouter,
  createWebHistory,
  NavigationGuardNext,
  RouteLocationNormalized,
  RouteRecordRaw
} from 'vue-router';
import Wrapper from '../modules/wrapper/Wrapper.vue';
import Login from '../modules/login/LoginPage.vue';
import {GET} from "@/core/http/methods";
import {AuthResponseData} from './models';
import {log} from '@/core/logger';
import store from '@/store';
import {RootActions} from "@/store/actions";
import { RootMutations } from '@/store/mutations';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'wrapper',
    component: Wrapper,
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/cl/:slug',
    name: "cl",
    component: Wrapper,
    meta: {
      requiresAuth: true,
      storeData: true,
    },
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(
  async (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext) => {
    if (!store.getters.SYSTEM_MODE) {
      await store.dispatch(RootActions.FETCH_SYSTEM_MODE);
    }
    if (to.meta?.storeData) {
      store.commit(RootMutations.SET_ROUTER_PARAMS, {
        name: to.name,
        params: to.params
      }, {root: true})
    }
    if (to.meta?.requiresAuth) {
      try {
        log(`validating user authenticity`);
        const response = await GET('auth/authorized');
        const data: AuthResponseData = response.data;
        if (data.isAuthorized) {
          // save username into store
          store.commit(RootMutations.SET_LOGGED_IN_USERNAME, {
            userName: data.username
          }, {root: true})
          log("user is authenticated, navigating to the requested route");
          next();
        } else {
          log("user is unauthorized, redirecting to the login page");
          next('/login');
        }
      } catch (error: any) {
        log(`failed validating user authenticity`);
      }
    } else {
      next();
    }
  })

export default router
